/**
 * Lingala (ln) bundle — draft glossary pending review (WP-16.7), assembled from three typed parts so a missing
 * or misspelt key fails the build. Terms not yet agreed appear in French through the i18next fallback.
 */
import type { Bundle } from "../i18n";
import { lnA } from "./ln-a";
import { lnB } from "./ln-b";
import { lnC } from "./ln-c";

// The **warehouse console** (`wh`) gained its draft on 2026-09-26, and it went first among the three that had none
// for the reason the plan gave: it is worked on a yard rather than at a desk, by people reading a screen with a
// scanner in one hand. The OneFleet module (`fleet`, D-16) and the master-data screens (`master`, D-142) are still
// French-first and fall back through i18next.
export const ln: Omit<Bundle, "fleet" | "master"> = { ...lnA, ...lnB, ...lnC };
